import { jsx } from 'react/jsx-runtime';
import cns from '../../../../node_modules/classnames/index.js';
import useModalContext from './useModalContext.js';

/**
 * Header di una modale.
*/
function Header({ children }) {
    const { dragging, onMouseDown } = useModalContext();
    return (jsx("div", { className: cns('v2-modal__header', 'can-grab', {
            grabbing: dragging,
        }), onMouseDown: onMouseDown, role: "presentation", children: children }));
}

export { Header as default };
